module.exports = __webpack_public_path__ + "static/05-2-8850cc73443399fb2c9ca718187a1525.jpg";